import { useIsEmbeddedConfluence_DO_NOT_USE } from '@confluence/embedded-confluence-check';
import { useEmbeddedEditPageFeatures } from '@confluence/embedded-confluence-allowed-features/entry-points/edit-page.ts';

/**
 * Returns whether the snippet create flow is enabled in the current context.
 *
 * Outside of Embedded Confluence, create is always enabled.
 * Inside Embedded Confluence, create is only enabled when the host has
 * allowed the `template-browser` or `template-browser-panel` feature.
 */
export const useIsSnippetCreateEnabled = (): boolean => {
	const isEmbeddedConfluence = useIsEmbeddedConfluence_DO_NOT_USE();
	const { isTemplateBrowserEnabled, isTemplateBrowserPanelEnabled } = useEmbeddedEditPageFeatures();

	if (!isEmbeddedConfluence) {
		return true;
	}

	return !!(isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled);
};
